import React, { Component } from 'react'
import { connect } from 'react-redux'
import PreAuthWithVaultSample from '../samples/PreAuthWithVaultSample'
import { makePreAuthWithVault } from '../../../actions/mcpActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _MCP, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    data_key: ["mcpResPreauthCC.SetData(data_key);", "mcpResPreauthCC.setData(data_key);", "'data_key'=>$data_key"],
    order_ID: ["mcpResPreauthCC.SetOrderId(order_id);", "mcpResPreauthCC.setOrderId(order_id);", "'order_id'=>$order_id"],
    electronic_commerce_indicator: ["mcpResPreauthCC.SetCryptType(crypt);", "mcpResPreauthCC.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    version_number: ["mcpResPreauthCC.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpResPreauthCC.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpResPreauthCC.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpResPreauthCC.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpResPreauthCC.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpResPreauthCC.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    customer_ID: ["mcpResPreauthCC.SetCustId(cust_id);", "mcpResPreauthCC.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpResPreauthCC.SetDynamicDescriptor(dynamic_descriptor);", "mcpResPreauthCC.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    final_authorization: ["mcpResPreauthCC.SetFinalAuth(\"true\");", "mcpResPreauthCC.setFinalAuth(\"true\");", "'final_auth' => ‘true’"],
    Credential_Info: ["mcpResPreauthCC.SetCofInfo(cof);", "mcpResPreauthCC.setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    AVS_Information: ["mcpResPreauthCC.SetAvsInfo(avsCheck);", "mcpResPreauthCC.setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: ["mcpResPreauthCC.SetCvdInfo(cvdCheck);", "mcpResPreauthCC.setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    
    rate_token: ["mcpResPreauthCC.SetMCPRateToken(\"MCP_RATE_TOKEN\");", "mcpResPreauthCC.setMCPRateToken(\"MCP_RATE_TOKEN\");", "'mcp_rate_token' => $mcp_rate_token"],
}


export class PreAuthWithVault extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakePreAuthWithVaultPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _MCP, orderId: newOrderId });
        const { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken } = this.props;
        const preAuthWithVaultRequest = { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken };
        this.props.makePreAuthWithVault(preAuthWithVaultRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
            <h3>Sample MCP Pre-Authorization with Vault</h3>
            <PreAuthWithVaultSample />
            <div className="requestButton" onClick={() => this.onMakePreAuthWithVaultPress()}>
                MCP Pre-Authorization with Vault Request
            </div> 
        </div>
        )
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Pre-Authorization with Vault</b></span>
                <p style={{marginTop: '3vh'}}>This transaction uses the data key to identify a previously registered credit card profile in Vault. The details saved within the profile are then submitted to perform a Pre-Authorization transaction.</p>
                <p>The data key may be a temporary one generated used Hosted Tokenization, or may be a permanent one from the Vault.</p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>
                

                <p><b>MCP Pre-Authorization with Vault transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>MCPResPreauthCC mcpResPreauthCC = new MCPResPreauthCC();</code>
                    case _JAVA:
                        return <code>MCPResPreauthCC mcpResPreauthCC = new MCPResPreauthCC();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_res_preauth_cc', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Pre-Authorization with Vault transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpResPreauthCC);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpResPreauthCC);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Purchase transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>data key</td>
                        <td><i>String</i><br /><br />25-character alphanumeri</td>
                        <td><code>{CODES.data_key[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Pre-Authorization with Vault transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor</td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>final authorization<br /><br /><p className="note"><b>NOTE: </b>Applies to Mastercard transactions only</p></td>
                        <td><i>String</i><br /><br />true/false</td>
                        <td><code>{CODES.final_authorization[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>Credential on File Info<br />cof<br /><br /><p className="note"><b>NOTE: </b>This is a nested object within the transaction, and required when storing or using the customer's stored credentials. For information about fields in the Credential on FIle Info object, see Credential on File Info Object and Variables.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Credential_Info[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>AVS Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.AVS_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>CVD Information<br /></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.CVD_Information[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP rate token</td>
                        <td><i>String</i><br /><br />N/A</td>
                        <td><code>{CODES.rate_token[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {updateOrderId, makePreAuthWithVault})(PreAuthWithVault)
